import React, { useEffect, useState } from 'react';
import { IonButton, IonIcon, IonPopover } from '@ionic/react';
import { checkmark, closeCircleOutline } from 'ionicons/icons';
import { _dict } from '../constants';

interface VideoPopoverProps {
  isOpen: boolean;
  onConfirm: (url: string | null) => void;
  lang: string;
}

const VideoPopover: React.FC<VideoPopoverProps> = ({ isOpen, onConfirm, lang }) => {
  const [url, setUrl] = useState<string>('');
  const [isValid, setIsValid] = useState<boolean|undefined>();
  const youtubeSearchRef = React.createRef<HTMLInputElement>();
  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        youtubeSearchRef.current?.focus();
      }, 500);
    }
  }, [isOpen]);

  const checkURL = (url: string) => {
    return(url.match(/^(https?\:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$/));
  }
  

  const handleUrlChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const urlInput = event.target.value;
    setUrl(urlInput);
    if(urlInput.trim() === ""){
      setIsValid(undefined);
    }else if(checkURL(urlInput)){      
      setIsValid(true);
    }else{
      setIsValid(false);
    }
    
  };

  const handleConfirm = () => {
    if (checkURL(url)) {
      onConfirm(url);
    } else {
      setIsValid(false);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleConfirm();
    }
  };

  const centerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  };

  const buttonStyle = {
    flex: '1',
    margin: '0px 20px 10px 20px'
  };

  const handleDismiss = () => {
    onConfirm(null);
    setIsValid(undefined);
  }
  return (
    <IonPopover isOpen={isOpen} onDidDismiss={handleDismiss} >
  <div style={{"padding": "5px"}}>
    <input
      ref={youtubeSearchRef}
      type="text"
      onChange={handleUrlChange}
      onKeyDown={handleKeyDown}
      placeholder={_dict.videoURLPlaceholder[lang]}
      autoFocus
      style={{
        width:"100%",
        height:"50px",
        border: 'none',
        
        borderBottom: '2px solid #4CAF50',
      }}
    />
    
  </div>
  {   isValid === true ? (
      <div >
        <IonButton onClick={handleConfirm} expand="full" color="success">
          <IonIcon icon={checkmark} size="large"  />
        </IonButton>
      </div>
      ) :
      isValid === false ? (
      <div>
        <IonButton onClick={handleDismiss} color="danger" expand="full">
          <IonIcon icon={closeCircleOutline} size="large" />
        </IonButton>
      </div>
    ) : null
  }
</IonPopover>

  );
};

export default VideoPopover;
